export const loginFormStyle = {padding:"47px 51px 14px 51px"}